import React from "react";
import { data, images } from "./data";

import './Gallery.css';

const Gallery = () => {
  return (
    <div className="bg-white flex flex-col-reverse sm:flex-row">
      <div className="flex-1 flex items-center p-0 sm:p-5 md:p-10">
        <ul className="gallery-parts list-disc ml-10 mt-5 sm:mt-0">
          {data.map((info, index) => (
            <li key={`il-${index}`}>{info}</li>
          ))}
        </ul>
      </div>
      <div className="w-full sm:w-3/5 space-y-0 grid gap-1 grid-cols-2 sm:grid-cols-3 grid-rows-3 sm:grid-rows-4">
        {images.map((image, index) => (
          <div className={`w-full rounded ${[1 , 3].includes(index) && 'sm:col-span-2 sm:row-span-2'}`}>
            <img
              className="object-cover"
              src={image}
              alt={`image-${index}`}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Gallery;
